module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox-multi-select"
  }, [_c('div', {
    staticClass: "checkbox-header",
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.displayText))])]), _vm._v(" "), (_vm.isOpen) ? _c('div', {
    staticClass: "checkbox-dropdown"
  }, _vm._l((_vm.options), function(option) {
    return _c('div', {
      key: option.value,
      staticClass: "checkbox-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedOptions),
        expression: "selectedOptions"
      }],
      attrs: {
        "type": "checkbox",
        "id": option.value
      },
      domProps: {
        "value": option.value,
        "checked": Array.isArray(_vm.selectedOptions) ? _vm._i(_vm.selectedOptions, option.value) > -1 : (_vm.selectedOptions)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedOptions,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedOptions = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedOptions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedOptions = $$c
          }
        }, _vm.updateSelection]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": option.value
      }
    }, [_vm._v(_vm._s(option.text))])])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f65b028","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/CheckboxMultiSelect.vue
// module id = 2620
// module chunks = 0